module.exports = __webpack_public_path__ + "img/card-header_customer.98ff769f.png";